import { ApolloError, useMutation } from "@apollo/client";
import { loader } from "graphql.macro";
import { Fragment, ReactElement, ReactNode } from "react";

import {
  CreateActivityItemMutation as CreateActivityItemMutationType,
  CreateActivityItemMutationVariables,
} from "./__generated__/CreateActivityItemMutation";

const CreateActivityItemMutation = loader("./CreateActivityItemMutation.gql");

type CreateActivityItemMutationProviderType = (props: {
  children: (loading: boolean, mutate: any) => ReactNode;
  onError: (error: ApolloError) => void;
  onCompleted: (data: CreateActivityItemMutationType) => void;
}) => ReactElement;

export const CreateActivityItemMutationProvider: CreateActivityItemMutationProviderType = (props) => {
  const { children, onError, onCompleted } = props;

  const [mutate, { loading }] = useMutation<CreateActivityItemMutationType, CreateActivityItemMutationVariables>(
    CreateActivityItemMutation,
    {
      errorPolicy: "none",
      onError,
      onCompleted,
    },
  );

  return <Fragment>{children(loading, mutate)}</Fragment>;
};
